import { Component, Input } from '@angular/core';
import { AiChatbotTemplateTunerGeneration } from '../../models/ai-chatbot-presentation-data';
import { AIChatbotService } from '../../services/ai-chatbot/ai-chatbot.service';
import { ModalService } from 'src/app/components/modals/modal.service';
import { LoadingService } from 'src/app/components/loading/loading.service';

@Component({
  selector: 'template-tuner-preview',
  templateUrl: './template-tuner-preview.component.html',
  styleUrl: './template-tuner-preview.component.scss',
  standalone: false,
})
export class TemplateTunerPreviewComponent {
  @Input() presentation!: AiChatbotTemplateTunerGeneration;
  @Input() optionNumber!: number;

  protected isCreatingPresentation = false;

  protected showBranding = this.aiChatbotService.showBranding;

  constructor(
    private aiChatbotService: AIChatbotService,
    private modalService: ModalService,
    private loadingService: LoadingService,
  ) {}

  closePreview(): void {
    this.aiChatbotService.clearSelectedTemplateTunerPreview();
  }

  async openInEditor(): Promise<void> {
    this.isCreatingPresentation = true;
    this.loadingService.start('template-tuner-editor-loader');

    try {
      await this.aiChatbotService.createPresentationFromTemplateTuner(
        this.presentation,
      );
    } catch (error) {
      console.error('Failed to open template in editor:', error);

      const errorMessage =
        error?.message ||
        'An unexpected error occurred while creating the presentation.';
      await this.modalService.showMessage(
        'Failed to Create Presentation',
        errorMessage,
      );

      this.closePreview();
    } finally {
      this.isCreatingPresentation = false;
      this.loadingService.stop('template-tuner-editor-loader');
    }
  }
}
